export default "__VITE_ASSET__DRNhghqD__"